import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LineForm3 } from "../cmp/LineForm3";
import { LineForm5 } from "../cmp/LineForm5CollecteurDetail";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { eventBus } from "../services/eventBusService";
import { loadCrms, removeCrm, setEditCrm } from "../store/actions/crmAction";

export function Modal5({ data3, keyData }) {
  const dispatch = useDispatch();
  const crms = useSelector((state) => state.crmReducer.crms);
  const crmIdxEdited = useSelector((state) => state.crmReducer.crmIdxEdited);

  const [isShown, setIsShown] = useState(true);

  const closeModal = () => {
    setIsShown(false);
    eventBus.emit("editing");
    eventBus.emit("added");
  };

  return (
    <Modal
      isOpen={isShown}
      toggle={closeModal}
      backdrop={true}
      keyboard={true}
      className="pt-1 pb-1"
    >
      <ModalHeader toggle={closeModal}>
        {keyData != null ? "Éditer une saisie" : "Ajouter une saisie"}
      </ModalHeader>

      <ModalBody className="pt-1">
        <LineForm5 closeModal={closeModal} data3={data3} keyData={keyData} />
      </ModalBody>
    </Modal>
  );
}
